(() => {
  if (window.pmClubPackAnimation) return;
  window.pmClubPackAnimation = true;
  const desktopEnabled=document.currentScript.dataset.desktopEnabled==='true';
  const assetBase = new URL('.', document.currentScript.src);
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const surface = document.createElement('div');
  surface.className = 'pm-pack-success';
  surface.hidden = true;
  surface.innerHTML = `<div class="pm-pack-card">
    <div class="pm-pack-scene" aria-hidden="true">
      <div class="pm-pack-halo"></div>
      <svg class="pm-pack-art" viewBox="0 0 280 250" fill="none">
        <ellipse cx="140" cy="228" rx="78" ry="9" fill="#183D2F" opacity=".1"/>
        <g class="pm-pack-bag">
          <path d="M70 111 91 96h105l18 15-9 107H78z" fill="#A97442"/>
          <ellipse cx="142" cy="110" rx="72" ry="13" fill="#735033"/>
          <path d="M111 107V82c0-37 61-37 61 0v25" stroke="#AC7747" stroke-width="8"/>
        </g>
        <g class="pm-pack-bento">
          <rect x="89" y="30" width="104" height="69" rx="17" fill="#123E30"/>
          <rect x="95" y="35" width="92" height="57" rx="12" fill="#F9F4DF"/>
          <path d="M151 39v48M156 64h26" stroke="#D3CEB7" stroke-width="3"/>
          <rect x="100" y="42" width="44" height="39" rx="9" fill="#E5B06C"/>
          <path d="m106 48 27 26m-29-15 17 16m-6-30 21 20" stroke="#A65B31" stroke-width="4" stroke-linecap="round"/>
          <circle cx="164" cy="50" r="8" fill="#638D44"/><circle cx="175" cy="49" r="7" fill="#7DAB50"/>
          <circle cx="167" cy="76" r="7" fill="#F47658"/><circle cx="179" cy="77" r="5" fill="#E6AC4C"/>
          <path d="M99 91h84" stroke="#C3E16B" stroke-width="3" stroke-linecap="round"/>
        </g>
        <g class="pm-pack-front">
          <path d="M70 111c41 15 103 15 144 0l-9 107c-38 12-89 12-127 0z" fill="#C99B65"/>
          <path d="m70 111 15 105 10-99M214 111l-14 105-8-99" fill="#B68753"/>
          <path d="M114 125v-8c0-34 54-34 54 0v8" stroke="#8B603B" stroke-width="6" stroke-linecap="round"/>
          <rect x="93" y="151" width="96" height="43" rx="7" fill="#FFFDF6"/>
          <image class="pm-pack-logo" x="99" y="155" width="84" height="35" preserveAspectRatio="xMidYMid meet"/>
        </g>
        <g class="pm-pack-check"><circle cx="207" cy="132" r="21" fill="#C8E86B"/><path d="m197 132 7 7 13-15" stroke="#123E30" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></g>
        <g class="pm-pack-spark" stroke="#F27559" stroke-width="3" stroke-linecap="round"><path d="M52 76v12m-6-6h12M228 67v12m-6-6h12"/></g>
      </svg>
    </div>
    <p class="pm-pack-message" role="status" aria-live="polite"></p>
  </div>`;
  surface.querySelector('image').setAttribute('href', new URL('purefect-logo-2026.png', assetBase).href);
  document.body.append(surface);
  const bagBack=surface.querySelector('.pm-pack-bag').innerHTML;
  const bagFront=surface.querySelector('.pm-pack-front').innerHTML;
  const boxBack='<path d="M65 119 101 96h89l28 23-15 98H78z" fill="#8A603A"/><path d="m65 119 36-23-20-20-37 25zM190 96l28 23 21-22-32-24z" fill="#DAB17D" stroke="#B88A54" stroke-width="2"/><path d="M101 96h89l17-23H81z" fill="#CBA16D"/>';
  const boxFront='<path d="m65 119 79 18 74-18-8 99-66 15-71-15z" fill="#C99B65"/><path d="m144 137 74-18-8 99-66 15z" fill="#B48551"/><path d="m65 119 79 18-8 23-81-21z" fill="#E0BA89" stroke="#BA905F" stroke-width="2"/><path d="m144 137 74-18 18 21-80 20z" fill="#D8AF7A" stroke="#BA905F" stroke-width="2"/><path d="M144 160v68" stroke="#96683B" stroke-width="2"/><rect x="78" y="170" width="62" height="34" rx="4" fill="#FFFDF6"/><image class="pm-pack-logo" x="82" y="173" width="54" height="28" preserveAspectRatio="xMidYMid meet"/>';
  function packaging(kind){
    surface.querySelector('.pm-pack-bag').innerHTML=kind==='club'?boxBack:bagBack;
    surface.querySelector('.pm-pack-front').innerHTML=kind==='club'?boxFront:bagFront;
    surface.querySelector('image').setAttribute('href',new URL('purefect-logo-2026.png',assetBase).href);
    surface.dataset.cart=kind;
  }
  let timer;
  function dismiss() {
    clearTimeout(timer);
    surface.hidden = true;
    surface.classList.remove('pm-pack-playing', 'pm-pack-still');
    surface.querySelector('[role="status"]').textContent = '';
  }
  function play(kind) {
    if (!matchMedia('(max-width: 749px)').matches && !desktopEnabled) return;
    dismiss();
    packaging(kind);
    surface.hidden = false;
    surface.querySelector('[role="status"]').textContent = kind==='club'?'Added to your Club Box':'Added to A La Carte';
    surface.classList.add(reducedMotion.matches ? 'pm-pack-still' : 'pm-pack-playing');
    timer = setTimeout(()=>{dismiss();clearPending();}, 2600);
  }
  const pendingKey='pm-cart-pack-pending';
  let scheduled;
  function clearPending(){try{sessionStorage.removeItem(pendingKey);}catch{}}
  function consume(){
    try{
      const pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
      if(pending&&Date.now()-pending.at<10000)play(pending.kind);
      else clearPending();
    }catch{clearPending();}
  }
  function added(kind){
    if(!matchMedia('(max-width:749px)').matches&&!desktopEnabled)return;
    try{sessionStorage.setItem(pendingKey,JSON.stringify({kind,at:Date.now()}));}catch{}
    clearTimeout(scheduled);scheduled=setTimeout(()=>play(kind),150);
  }
  if(window.PurefectClubCart){
    const originalAdd=window.PurefectClubCart.add;
    window.PurefectClubCart.add=async function(...args){const result=await originalAdd.apply(this,args);added('club');return result;};
  }
  const originalFetch=window.fetch;
  window.fetch=async function(input,options){
    const response=await originalFetch.call(this,input,options);
    try{
      const url=new URL(typeof input==='string'||input instanceof URL?input:input.url,location.href);
      const method=(options?.method||input?.method||'GET').toUpperCase();
      if(method==='POST'&&url.origin===location.origin&&/\/cart\/add(?:\.js|\.json)?\/?$/.test(url.pathname)&&response.ok){
        const result=await response.clone().json();
        if(!result.status&&!result.errors&&(result.id||result.items?.length))added('regular');
      }
    }catch{}
    return response;
  };
  window.addEventListener('pageshow',consume);
  if(document.readyState==='complete')consume();
  function dismissByUser(){dismiss();clearPending();}
  document.addEventListener('pointerdown', () => { if (!surface.hidden) dismissByUser(); }, { passive:true });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') dismissByUser(); });
  window.addEventListener('pagehide', dismiss);
  reducedMotion.addEventListener('change', dismiss);
})();

